import React from 'react';
import { Button } from '@components';
import { Input } from 'gd-design-library';
import { getFormFields } from './form';
import { useForm } from 'hooks';

import styles from './NameForm.module.scss';
import classnames from 'classnames/bind';

const CN = 'name-form';
const fieldClassName = `${CN}--field`;

const cx = classnames.bind(styles);

interface NameFormProps {
    initialFirstName?: string;
    initialLastName?: string;
    onSave: (firstName: string, lastName: string) => void;
    className?: string;
    isLoading: boolean;
}

export const NameForm: React.FC<NameFormProps> = ({ initialFirstName, initialLastName, onSave, className, isLoading }) => {
  const formFields = getFormFields(initialFirstName, initialLastName);
  const {
    state,
    errors,
    handleChange,
    handleBlur,
    isValid
  } = useForm(formFields);

  return <form className={ cx(CN, className) }>
    <Input
      className={ cx(fieldClassName) }
      name='firstName'
      variant='text'
      label='First Name'
      value={ state.firstName }
      onBlur={ handleBlur }
      onChange={ handleChange }
      helperText={ errors.firstName.isTouched && !errors.firstName.isValid ? errors.firstName.message : '' }
      color={ errors.firstName.isTouched && !errors.firstName.isValid ? 'error' : 'primary' }
    />
    <Input
      className={ cx(fieldClassName) }
      name='lastName'
      variant='text'
      label='Last Name'
      value={ state.lastName }
      onBlur={ handleBlur }
      onChange={ handleChange }
      helperText={ errors.lastName.isTouched && !errors.lastName.isValid ? errors.lastName.message : '' }
      color={ errors.lastName.isTouched && !errors.lastName.isValid ? 'error' : 'primary' }
    />
    <Button
      loading={ isLoading }
      disabled={ !isValid }
      onClick={ (): void => onSave(state.firstName, state.lastName) }
    >
      Save
    </Button>
  </form>;
};
